import { createContext, useContext, useState, useEffect } from "react";

const ThemeContext = createContext({ light: false, toggle: () => {} });

export const useTheme = () => useContext(ThemeContext);

export const ThemeProvider = ({ children }) => {
  const [light, setLight] = useState(() => localStorage.getItem("theme") === "light");

  useEffect(() => {
    localStorage.setItem("theme", light ? "light" : "dark");
    if (light) {
      document.documentElement.classList.add("light-mode");
    } else {
      document.documentElement.classList.remove("light-mode");
    }
  }, [light]);

  const toggle = () => setLight((prev) => !prev);

  return (
    <ThemeContext.Provider value={{ light, toggle }}>
      {children}
    </ThemeContext.Provider>
  );
};
